import type { CofQuizQuestion, CofQuizVerdict } from '@tunasong/music-lib'
import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './cof-quiz-feedback.module.css'

export interface CofQuizFeedbackProps {
  question: CofQuizQuestion
  verdict: CofQuizVerdict
  onHearAgain: () => void
  onNext: () => void
}

/**
 * CoF Wheel v1 Quiz feedback surface — verdict + replay + next. The
 * incorrect branch surfaces the canonical accepted answer set verbatim so
 * the user learns the relationship; the `find-closely-related` 5-key set
 * lists all 5 since any of them would have been correct.
 *
 * Spec: docs/superpowers/specs/2026-05-23-cof-wheel-v1-design.md §9
 */
export const CofQuizFeedback: FC<CofQuizFeedbackProps> = props => {
  const { question, verdict, onHearAgain, onNext } = props
  // Deduplicate enharmonic spellings for the displayed answer list.
  const dedupedAnswers = [...new Set(question.acceptedAnswers)].join(', ')
  return (
    <section className={styles.panel} aria-label="Quiz feedback">
      {verdict.correct ? (
        <p className={styles.correct}>Correct!</p>
      ) : (
        <p className={styles.incorrect}>Not quite. Accepted answers: {dedupedAnswers}.</p>
      )}
      <div className={styles.actions}>
        <Button variant="outlined" size="small" onClick={onHearAgain}>
          Hear again
        </Button>
        <Button variant="contained" size="small" onClick={onNext}>
          Next
        </Button>
      </div>
    </section>
  )
}
